var _excluded = ["text", "skin", "size", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, oneOf } from 'prop-types';
import classNames from 'classnames';
import './StatusBadge.scss';
var propTypes = {
  /** The text on the badge. Normally a Ruter line number or similar. */
  text: string.isRequired,

  /** Background and color */
  skin: oneOf(['neutral', 'dark', 'success', 'warning', 'danger', 'info']),

  /** You can choose a size for the badge. */
  size: oneOf(['small', 'medium', 'large']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  skin: 'neutral',
  size: 'small'
};
/** A colored text component suitable for displaying status */

var StatusBadge = function StatusBadge(_ref) {
  var text = _ref.text,
      skin = _ref.skin,
      size = _ref.size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-status-badge', 'rds-status-badge__txt', {
    'rds-status-badge--neutral': skin === 'neutral' || !skin || skin === 'default',
    'rds-status-badge--dark': skin === 'dark',
    'rds-status-badge--success': skin === 'success',
    'rds-status-badge--warning': skin === 'warning',
    'rds-status-badge--danger': skin === 'danger',
    'rds-status-badge--info': skin === 'info',
    'rds-status-badge--small': size === 'small' || !size,
    'rds-status-badge--medium': size === 'medium',
    'rds-status-badge--large': size === 'large'
  }, className);
  {
    skin === 'default' && console.error("Skin 'default' is deprecated. Please use 'neutral' instead.");
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: componentClassNames
  }, rest), text);
};

StatusBadge.propTypes = propTypes;
StatusBadge.defaultProps = defaultProps;
export default StatusBadge;